import { Box, Stack, Typography, Divider } from "@mui/material";
import "./index.scss";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Images } from "../../assets/common";
import NoData from "../../components/Nodata";
import ArtistMusicTabRow from "../ArtistMusicTabRow";
import HMSTag from "../HMS/hms";


export default function ArtistMusicTab({
  play,
  actions,
  toggleMenu,
  reference,
  data,
  history
}) {
  const { t } = useTranslation("common");
 

  return (
    <Box>
      {data.map((e,albumIndex) => {
        return (
          <div>
            <div className="album_cover_box">
              <div className="album_cover">
                <img
                  src={
                    e?.thumbnailImg?.filePath ??
                    e?.GIF?.filePath ??
                    Images.dummy
                  }
                  onClick={() => {
                    // Play the first song of this album/single
                    if (e.music && e.music.length > 0) {
                      play(0, e.music);
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <div style={{ marginLeft: "24px" }}>
                <Typography
                  onClick={()=>{
                    history.push(`/app/AlbumDetail/${e["_id"]}`);
                  }}
                  variant="body1"
                  className="fs-16 _cp"
                  sx={{ textAlign: "left", fontSize: "20px" }}
                >
                  {e.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: "left",
                    fontSize: "14px",
                    color: "#FFFFFFCC",
                    marginTop: "12px ",
                  }}
                > 
                  {e.displayArtistName?.toString() ?? ""}
                </Typography>
                <Stack
                  direction="row"
                  gap="8px"
                  style={{ marginTop: "10px", alignItems: "center" }}
                >
                  <Typography variant="body2" className="white-secondary">
                    {(e.music?.length || 0) + " Songs"}
                  </Typography>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ backgroundColor: "#FFFFFFCC" }}
                  />
                  <HMSTag
                    className="white-secondary"
                    style={{
                      textAlign: "left",
                      fontSize: "12px",
                    }}
                    duration={e.totalDuration}
                  />
                </Stack>
              </div>
            </div>
            <Stack spacing={0} sx={{ position: "relative" }}>
              <Stack spacing={0}>
                <table className="mymusic_table" style={{ tableLayout: "fixed", width: "100%" }}>
                  <thead
                    style={{
                      position: "sticky",
                      top: "0",
                      zIndex: "1",
                      backgroundColor: "#090909",
                    }}
                  >
                    <tr sx={{ justifyContent: "start" }}>
                      <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "20px", width: "35%" }}>{t("trending.tabs.th1")}</th>
                      <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "20%" }}>
                        {t("trending.tabs.th2")}
                      </th>
                      <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "12%" }}>{t("trending.tabs.th3")}</th>
                      <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "18%" }}>{t("trending.tabs.th4")}</th>
                      <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "10%" }}>{t("trending.tabs.th5")}</th>
                      <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", width: "5%" }}>{t("trending.tabs.th6")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(e.music?.length || 0) > 0 ? (
                      e.music.map((transaction, index) =>
                        index == e.music.length - 1 ? (
                          <ArtistMusicTabRow
                            reference={reference}
                            lastIndex={index == e.music.length - 1}
                            data={transaction}
                            play={() => play(index, e.music)}
                            actions={actions}
                            toggleMenu={(action, id) =>
                              toggleMenu(action, id, albumIndex)
                            }
                            music={true}
                            uId={transaction}
                          />
                        ) : (
                          <ArtistMusicTabRow
                            lastIndex={index == data.length - 1}
                            data={transaction}
                            play={() => play(index, e.music)}
                            actions={actions}
                            toggleMenu={(action, id) =>
                              toggleMenu(action, id, albumIndex)
                            }
                            music={true}
                            uId={transaction}
                          />
                        )
                      )
                    ) : (
                      <NoData lable={t("noData.message20")} />
                    )}
                  </tbody>
                </table>
              </Stack>
            </Stack>
            <Divider style={{ marginBottom: "24px" }} />
          </div>
        );
      })}
    </Box>
  );
}
